<template>
    <vue-context
        ref="contextMenu"
        @close="reset"
        :close-on-click="false"
    >
        <div :class="$spa.css.contextmenu.container" v-if="model">
            <slot v-bind:model="model" v-bind:data="data"></slot>
        </div>
    </vue-context>
</template>

<style>
    .v-context {
        display: block;
        z-index: 1500;
        position: fixed;
    }
    .v-context:focus,
    .v-context > li > a:focus,
    .v-context ul:focus,
    .v-context ul > li > a:focus {
        outline: 0;
    }
</style>

<script>
    import VueContext from 'vue-context';
    
    export default {
        components: {
            VueContext
        },

        props: {
            modelClass: {
                type: Function,
                required: true
            },
        },

        data() {
            return {
                model: null,
                data: {},
            }
        },

        methods: {
            getContextMenuEvent()
            {
                return this.modelClass.getContextMenuEvent();
            },

            open(data)
            {
                this.$bus.$emit('all-context-menu:close');
            
                console.log('Context menu opened', data);
                this.model = data.model;
                this.data = data.data || {};

                this.$emit('opening', data);
                this.$refs.contextMenu.open(data.event);
                this.$emit('opened', data);
            },
            
            close()
            {
                this.$emit('closing');
                this.$refs.contextMenu.close();
                this.$emit('closed');
            },

            reset()
            {
                this.$emit('resetting');
                this.model = null;
                this.data = {};
                this.$emit('resetted');
            },
        },

        created()
        {
            this.$bus.$on(this.getContextMenuEvent(), this.open);
            this.$bus.$on('all-context-menu:close', this.close);
        },

        beforeDestroy()
        {
            this.$bus.$off(this.getContextMenuEvent(), this.open);
            this.$bus.$off('all-context-menu:close', this.close);
        }
    }
</script>